export default __webpack_public_path__ + "static/media/mm-phone.803e8a74.png";